import React from 'react';
import GenericLink from 'components/GenericLink';
import BasedOnDatesLink from 'components/dashboard/common/BasedOnDatesLink';
import StatItem from 'components/dashboard/StatItem';
import Loading from 'components/pure/utils/Loading';
import RepProfilePageActions from 'actions/RepProfilePageActions';
import RepProfileTrendChartContainer from '$pages/@common/rep-profile-trend-chart/RepProfileTrendChartContainer';
import {maxByReplacingNaN, sortByReplacingNaN} from 'utils/NaN';
import {callDrillDown} from 'components/dashboard/rollups/topic/CallDrillDown';

/**
 * Drill down into a team, displaying stats for its users.
 */
export default class TopicRollupTeamDrillDown extends React.PureComponent {
  render() {
    const {
      chartLabelFn,
      color,
      endDate,
      error,
      goBack,
      goBackText,
      startDate,
      headerStartDate,
      headerEndDate,
      loading,
      location,
      stats,
      subtabConfig,
      triggerId,
      triggerNameFromStat,
      users,
    } = this.props;

    if (loading) {
      return <Loading />;
    }
    if (error) {
      return <div>Problem loading the data.</div>;
    }

    const fetchTrendData = stat => {
      if (this.props.isPercent) {
        RepProfilePageActions.getTopicPercentageTrend({
          userId: stat.id,
          startDate,
          endDate,
          context: triggerId,
        });
      } else {
        RepProfilePageActions.getTrendData({
          userId: stat.id,
          startDate,
          endDate,
          context: triggerId,
          type: 'trigger',
        });
      }
    };

    const max = maxByReplacingNaN(stats.map(stat => stat.value));
    const getLinkAndName = stat => {
      const user = users
        .valueSeq()
        .filter(user => user.userId === stat.id)
        .first();
      return user ? [user.getFullName(), user.getFullName()] : [null, null];
    };

    return (
      <div className="rep-stat-tab-content">
        <div>{goBack && <GenericLink onClick={goBack}>{goBackText}</GenericLink>}</div>
        <div className="description">{subtabConfig.drillDownDescriptionFn(triggerId)}</div>
        <BasedOnDatesLink startDate={headerStartDate} endDate={headerEndDate} location={location} />
        <div className="bar-container">
          {sortByReplacingNaN(stats, stat => stat.value)
            .reverse()
            .map(stat => (
              // TODO chart should use header date range...possibly need to adjust gross clone to make
              // it happen, and it's only off by one on the chart's x-axis, so maybe another time.
              <StatItem
                key={stat.id}
                chartLabelFn={chartLabelFn}
                color={color}
                fetchTrendData={() => fetchTrendData(stat)}
                formatValue={subtabConfig.formatValue}
                getLinkAndName={getLinkAndName}
                max={max}
                stat={stat}
                title={triggerNameFromStat(stat)}
                trendComponent={RepProfileTrendChartContainer}
                onOpenDrillDown={callDrillDown({startDate, endDate})}
              />
            ))}
        </div>
      </div>
    );
  }
}
